
        
          <div class="wrapper fadeInDown">
            <div id="formContent">
              <h4>Cambio de password</h4>
              <form autocomplete="off" [formGroup]="formAdmin" (ngSubmit)="onSubmit(formAdmin.value)" >

        <div class="form-group">
          <input type="email" class="formControl" formControlName="email" placeholder="Introduzca Email" #passwordResetEmail required>
        </div>
 
        <!-- Calling ForgotPassword from AuthService Api -->
       
          <!-- Calling SignIn Api from AuthService -->
          <div class="formGroup">
            <input type="submit" id="button" class="btn btnPrimary" value="Reset Password" #passwordResetEmail>
          </div>
        </form>
      <div id="formFooter">
      <div class="redirectToLogin">
        <span>Volver a? </span><a class="redirect" routerLink="/sign-in">Acceder</a> 
      </div>
    </div>
      </div>
      </div>
  

